import React, { useContext } from "react";
import { Link } from "react-router-dom";
import LanguageContext from "../utils/Contexts/LanguageContext";
import KeyboardModal from "../modals/KeyboardModal";

function Footer() {
  const { t } = useContext(LanguageContext);

  return (
    <div className="footer">
      <div className="row justify-content-between align-items-center">
        <div className="col">
          <p className="fs-6 mb-0">{new Date().getFullYear()} &copy; {t("Backlinks Factory")}</p>
        </div>

        <div className="col-auto">
          <div className="d-flex justify-content-end">
            <ul className="list-inline list-separator">
              <li className="list-inline-item">
                <Link className="list-separator-link" href="/offers-search">
                  {t("FAQ")}
                </Link>
              </li>

              <li className="list-inline-item">
                <Link className="list-separator-link" href="/offers-search">
                  {t("License")}
                </Link>
              </li>

              <li className="list-inline-item">
                <button
                  className="btn btn-ghost-secondary btn btn-icon btn-ghost-secondary rounded-circle"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasKeyboardShortcuts"
                  aria-controls="offcanvasKeyboardShortcuts"
                >
                  <i className="bi-command"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <KeyboardModal />
    </div>
  );
}

export default Footer;
